import styles from "./styles.module.scss";
import React from "react";
const Label = ({
  text,
  item,
  required = false,
  visible = true,
  tooltip = null,
  containerStyle = null,
  error = "",
  showUnder = false,
  textMarginLeft = 0,
}) => {
  if (!visible) {
    return null;
  }

  const adornments = (
    <>
      {required && <span className={styles.required}>*</span>}
      {tooltip && <div className={styles.tooltip_inline}>{tooltip}</div>}
    </>
  );

  // The tooltip node (ToolTip) renders a <div>, so its wrappers must be
  // block-level elements — a <div> nested in a <span> is invalid HTML. The
  // wrappers below are <div>s kept inline-level via CSS so text still flows.

  // Keep the required "*" and tooltip glued to the last word of the label so
  // they wrap together with it (e.g. "Contacts? * i") instead of landing alone
  // on their own row when the label is long. Only applies to multi-word labels:
  // a label with no spaces (e.g. CJK translations) would otherwise become one
  // non-wrapping run and overflow, so it falls back to the normal render.
  const renderLabelText = () => {
    if (typeof text === "string" && text.trim().includes(" ") && (required || tooltip)) {
      const words = text.split(" ");
      const lastWord = words.pop();
      const head = words.join(" ");
      return (
        <div className={styles.text} style={{ marginLeft: textMarginLeft || 0 }}>
          {head ? `${head} ` : ""}
          <div className={styles.nowrap_tail}>
            {lastWord}
            {adornments}
          </div>
        </div>
      );
    }
    return (
      <div className={styles.text} style={{ marginLeft: textMarginLeft || 0 }}>
        {text}
        {adornments}
      </div>
    );
  };

  return (
    <div className={containerStyle || styles.container}>
      <div className={showUnder ? "" : styles.label_container}>
        <div className={showUnder ? styles.close : styles.text_container}>
          {renderLabelText()}
        </div>
        {error && <span className={styles.error}>{error}</span>}
      </div>
      {item}
    </div>
  );
};

export default Label;
